import * as React from 'react'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { IEntityAppointment } from '@user/store/scheduling'
import { ExternalLink } from '@sales-center/components'
import { useGetCardData } from './AppointmentsCardElements/hooks'
import { CardFooter, ContentRight, Details } from './AppointmentsCardElements'
import AddressMapLink from '@user/features/MapView/AddressMapLink/AddressMapLink'

export type AppointmentsCardProps = {
  entityAppointment: IEntityAppointment
  onOpenNestedDialog: (completeView: boolean) => void
  onCloseMain: () => void
}

export function AppointmentsCard(props: AppointmentsCardProps) {
  const { entityAppointment, onOpenNestedDialog } = props

  const {
    appointmentId,
    tech,
    workTime,
    timeRange,
    scheduledBy,
    appointmentNumber,
    appointmentType,
  } = entityAppointment

  const { orderUrl, allowActions, formattedAddress } =
    useGetCardData(entityAppointment)

  return (
    <>
      <Stack
        pt={1}
        px={2}
        pb={2.5}
        direction="row"
        justifyContent="space-between"
      >
        <Stack mr={2}>
          <Typography my={1.2} variant="body2">
            Appointment Type: {appointmentType}
          </Typography>

          <AddressMapLink
            address={formattedAddress}
            entityId={entityAppointment.entityId}
            entityType={entityAppointment.entityType}
            serviceLocationId={
              entityAppointment.serviceLocationId ||
              entityAppointment.serviceLocationAddress?.serviceLocationId
            }
            latitude={entityAppointment.serviceLocationAddress?.latitude}
            longitude={entityAppointment.serviceLocationAddress?.longitude}
          >
            {formattedAddress}
          </AddressMapLink>

          <Typography my={1.2} variant="body2">
            Order&nbsp;
            <ExternalLink
              href={orderUrl}
              label={appointmentNumber}
              dataTestId={`external-link-${appointmentId}`}
            />
          </Typography>

          <Details
            techName={tech}
            scheduledBy={scheduledBy ?? '-'}
            appointmentId={appointmentId}
          />
        </Stack>

        <ContentRight
          appointmentId={appointmentId}
          workTime={workTime}
          orderUrl={orderUrl}
          timeRange={timeRange}
          allowActions={allowActions}
          onOpenNestedDialog={onOpenNestedDialog}
        />
      </Stack>

      {allowActions ? (
        <CardFooter
          {...props}
          allowActions={allowActions}
          appointmentId={appointmentId}
        />
      ) : (
        <Box px={2} pb={1.4}>
          <Alert severity="info">
            Scheduled Services cannot be managed in Sales Center
          </Alert>
        </Box>
      )}
    </>
  )
}
